import React from "react";
import Index from "../components/login";

export default function Login() {
 
  return (
    <>
      <Index />
    </>
  );
}
